
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 48c13.3 0 24-10.7 24-24S37.3 0 24 0 0 10.7 0 24s10.7 24 24 24z","fill":"#4fa2b7"}}),_c('path',{attrs:{"d":"M16.4 25.1H3.9V23h12.5v2.1zm27.7 0H31.6V23h12.5v2.1zm-16.9 3.3l-2.9-2.9-2.9 2.9-1.5-1.5 2.9-2.9-2.9-2.9 1.5-1.5 2.9 2.9 2.9-2.9 1.5 1.5-3 2.9 2.9 2.9-1.4 1.5z","fill":"#fff"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/blockageFill.svg